<div class="new-search-link-container">
  <a class="new-search-link" (click)="redirectClick()">
    <span class="new-search-link-text">New Search</span>
    <mat-icon class="new-search-link-icon">cached</mat-icon>
  </a>
</div>